import React from 'react';
import { TEACHER_MENU } from '../../utils/const';
import MenuLink from './MenuLink';

// Состав меню — в utils/const (TEACHER_MENU), один источник с поиском по меню.
const TeacherMenu = () => (
  TEACHER_MENU.map(({ name, to, checkAccess }) => (
    <MenuLink checkAccess={checkAccess} name={name} to={to} key={to} />
  ))
);

export default TeacherMenu;
